import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'outline' | 'red';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  const variants = {
    default: 'bg-[#1f1f1f] text-gray-300 border border-[#333]',
    outline: 'bg-transparent text-gray-400 border border-[#333]',
    red: 'bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 shadow-[0_0_10px_rgba(210,43,43,0.1)]'
  };
  return <span className={`
      inline-flex items-center px-2.5 py-0.5 
      text-[10px] font-serif uppercase tracking-widest
      ${variants[variant]}
      ${className}
    `} data-id="element-168">
      {children}
    </span>;
}